import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";

export default function ChipsArray(props) {
	const classes = useStyles();
	return (
		<Grid
			item
			xs={12}
			component="ul"
			className={clsx(classes.root, {
				[classes.topTagArray]: props.position === 'top',
				[classes.middleTagArray]: props.position === 'middle',
				[classes.bottomTagArray]: props.position === 'bottom',
			})}
		>

			<li key={`${props.header}__top`} className={classes.li}>
				<Chip
					style={{ backgroundColor: props.data['P_DirectionsID'] === 1 ? "#683EDF" : props.data['P_DirectionsID'] === 2 ? "#D61C62" : props.data['P_DirectionsID'] === 3 ? "#0A9539" : props.data['P_DirectionsID'] === 4 ? "#06A1C2" : props.data['P_DirectionsID'] === 5 ? "#4DBCCB" : "#8094FF" }}
					label={props.header}
					className={classes.chip}
					onClick={() => document.location.href = `/products/cftbank/prodlist?area=${props.data['P_DirectionsID']}`}
				/>
			</li>
		</Grid>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		// justifyContent: 'center',
		flexWrap: 'wrap',
		listStyle: 'none',
		color: '#F00',
		justifyContent: 'start',
		padding: '0 12px'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},

	li: {
		margin: '0 3.5px',

		'&:first-child': {
			marginLeft: 0
		},

		'&:last-child': {
			marginRight: 0
		},
	},

	topTagArray: {
		padding: '0 0 8px 0 !important',
		justifyContent: 'flex-end',
	},

	middleTagArray: {
		padding: '0 12px !important',
	},

	bottomTagArray: {
		padding: '0 12px !important',
	}
}));